import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const tasksApiRoutes = {
    get: new URL("tasks/", apiDataManagerBaseURL),
};

export class ProgressbarAPI {
    static get(oldData) {
        return API.authenticatedRequest({
            url: tasksApiRoutes.get,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(oldData),
        });
    }
}
